// ── 6 Erster Tenant-Admin ── Zustand und Rumpf (rein).

import type { Tenant } from "../../api/types";

export interface FirstAdminState {
  email: string;
  name: string;
}

export type FirstAdminBody = FirstAdminState;

export function firstAdminFromTenant(t: Tenant): FirstAdminState {
  const a = t.first_admin ?? {};
  return { email: a.email ?? "", name: a.name ?? "" };
}

export function firstAdminToBody(s: FirstAdminState): FirstAdminBody {
  return { email: s.email, name: s.name };
}
